module.exports = __webpack_public_path__ + "media/images/TrustPilot-5a8831d6.png";